import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'

import DecorativeButton from '../decorativeButton'

import { StyledForm, StyledPot } from './../form/styles'
import DecorativeTextArea from '../decorativeTextArea'

const MessageForm = ({ personalDetails, onSuccess }) => {
  const [values, setValues] = useState({
    ...personalDetails,
    uuid: { value: 'B88CF84B-EDFB-6B15-D587-B787E6F394B0', valid: true },
    campaign_code: { value: 'FOREMYCNY2020BLESSINGFUTURE', valid: true },
  })

  const [isDisabled, setIsDisabled] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const formRef = useRef(null)

  const constraints = {
    future_message: { required: true },
  }

  const checkIfValid = name => (values[name] ? values[name].valid : true)

  const checkIfEmail = email => {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  const checkIfPhoneNumber = phone => {
    const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{2,8}$/im
    return re.test(phone)
  }

  const checkIfNumber = number => {
    const re = /^[0-9]*$/im
    return re.test(number)
  }

  const validateField = (name, value = '') => {
    let valid = false
    const constraint = constraints[name]

    if (constraint.required && !value) valid = false
    else if (constraint.numeric) valid = checkIfNumber(value)
    else if (constraint.email) valid = checkIfEmail(value)
    else if (constraint.phone) valid = checkIfPhoneNumber(value)
    else valid = true

    return valid
  }

  const onChange = e => {
    const value = e.target.type === 'checkbox' ? +e.target.checked : e.target.value
    const name = e.target.getAttribute('name')

    const valid = validateField(name, value)

    setValues({
      ...values,
      [name]: {
        value,
        valid,
      },
    })
  }

  const onSubmit = e => {
    e.preventDefault()
    if (isDisabled || isSubmitting) return

    const currentValues = {}
    let isAllValid = true

    const allFields = formRef.current.querySelectorAll('input:not([name="person"]), textarea, select')

    allFields.forEach(field => {
      const name = field.name
      const value = field.type === 'checkbox' ? +field.checked : field.value
      const valid = validateField(name, value)

      if (!valid) isAllValid = false

      currentValues[name] = {
        value,
        valid,
      }
    })

    setValues({ ...values, ...currentValues })
    if (isAllValid) setIsSubmitting(true)
  }

  useEffect(() => {
    if (!isSubmitting) return

    const formData = new FormData()
    Object.keys(values).forEach(field => formData.set(field, values[field].value))

    if (onSuccess) onSuccess(values)

    axios
      .post('https://sm-admin.forefront.international/server/api/registration', formData)
      .then(e => {
        setIsSubmitting(false)

        if (e.data.error) {
          console.error(e)
          return
        }

        setIsSubmitted(true)
      })
      .catch(e => {
        setIsSubmitting(false)
        console.error(e)
      })
  }, [isSubmitting])

  return (
    <StyledForm onSubmit={onSubmit} ref={formRef}>
      <StyledPot type="text" name="person" onChange={() => setIsDisabled(true)} />
      <div style={{ textAlign: 'center' }}>
        <DecorativeTextArea
          placeholder="Hey, future me! Great job getting that raise. I’m so proud of you! Even when times were tough, you did great believing in yourself beyond doubts, and doing your best."
          name="future_message"
          rows="4"
          onChange={onChange}
          isValid={checkIfValid('future_message')}
        />
      </div>
      <div style={{ textAlign: 'center' }}>
        <DecorativeButton>SUBMIT</DecorativeButton>
      </div>
    </StyledForm>
  )
}

export default MessageForm
